import { SET_NEW_PRODUCTS_PAGE, SET_BESTSELLER_PRODUCTS_PAGE } from 'constants/actionTypes/storeAggregation';

const initialState = {
    isInitialized: false,
    items: [],
    deliveryOptions: {}
};

const reducer = function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_NEW_PRODUCTS_PAGE:
        case SET_BESTSELLER_PRODUCTS_PAGE: {
            const { currentPage, ...restPayload } = payload;

            // Append newly fetched items to the existing list
            // when additional items are loaded through the "Load more" button
            const items = currentPage > 1 ? [...state.items, ...restPayload.items] : restPayload.items;

            const nextState = { ...state, isInitialized: true, ...restPayload, items };

            return nextState;
        }

        default: {
            return state;
        }
    }
};

export default { reducer, initialState };
